<template>
  <div class="testing-orders">
    <el-form 
      ref="testForm" 
      :model="form" 
      :rules="rules" 
      label-width="120px"
      class="test-form">
      <h3 class="form-title">上传测试结果</h3>
      
      <!-- 订单基本信息 -->
      <el-card class="form-card">
        <div slot="header">
          <span>订单基本信息</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="订单编号" prop="orderNo">
              <el-input v-model="form.orderNo" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建时间" prop="createTime">
              <el-input v-model="form.createTime" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="仪器类型" prop="deviceType">
              <el-input v-model="form.deviceType" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="仪器数量" prop="deviceCount">
              <el-input v-model="form.deviceCount" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <!-- 测试结果信息 -->
      <el-card class="form-card">
        <div slot="header">
          <span>测试结果信息</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="测试结果" prop="testResult">
              <el-radio-group v-model="form.testResult">
                <el-radio label="PASS">通过</el-radio>
                <el-radio label="FAIL">不通过</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="测试报告" prop="testReport">
              <el-upload
                class="upload-demo"
                action="/api/admin/upload"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                :on-success="handleSuccess"
                :on-error="handleError"
                multiple
                :limit="3"
                :file-list="form.fileList">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png/pdf文件，且不超过10MB</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="测试说明" prop="testDescription">
              <el-input 
                type="textarea" 
                v-model="form.testDescription"
                :rows="4"
                placeholder="请输入测试说明，包括测试项目、测试方法、测试结果等">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <!-- 操作按钮 -->
      <div class="form-actions">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">提交测试结果</el-button>
      </div>
    </el-form>

    <base-status-orders :status="'TESTING'" :title="'测试中订单'" :show-actions="true">
      <!-- 可以添加操作按钮插槽 -->
    </base-status-orders>
  </div>
</template>

<script>
import { adminApi } from '@/api'

export default {
  name: 'TestingOrders',
  data() {
    return {
      form: {
        orderNo: '',
        createTime: '',
        deviceType: '',
        deviceCount: '',
        testResult: '',
        testDescription: '',
        fileList: []
      },
      rules: {
        testResult: [
          { required: true, message: '请选择测试结果', trigger: 'change' }
        ],
        testDescription: [
          { required: true, message: '请输入测试说明', trigger: 'blur' }
        ],
        fileList: [
          { required: true, message: '请上传测试报告', trigger: 'change' }
        ]
      }
    }
  },
  created() {
    // 获取订单详情
    this.getOrderDetail()
  },
  methods: {
    async getOrderDetail() {
      try {
        const orderId = this.$route.params.id
        const res = await adminApi.getOrderDetail(orderId)
        if (res) {
          this.form = {
            ...this.form,
            orderNo: res.orderNo,
            createTime: res.createTime,
            deviceType: res.deviceType,
            deviceCount: res.deviceCount
          }
        }
      } catch (error) {
        console.error('获取订单详情失败:', error)
        this.$message.error('获取订单详情失败')
      }
    },
    handleCancel() {
      this.$router.back()
    },
    handleSubmit() {
      this.$refs.testForm.validate(async valid => {
        if (valid) {
          try {
            const orderId = this.$route.params.id
            await adminApi.updateOrderStatus({
              id: orderId,
              status: 'TESTED',
              ...this.form
            })
            this.$message.success('测试结果提交成功')
            this.$router.push('/admin/orders')
          } catch (error) {
            console.error('提交测试结果失败:', error)
            this.$message.error('提交测试结果失败')
          }
        }
      })
    },
    handlePreview(file) {
      // 调用统一的预览方法
      adminApi.previewFile(file, this.$message)
        .catch(error => {
          console.error('文件预览失败:', error);
        });
    },
    handleDownload(file) {
      // 调用统一的下载方法
      adminApi.downloadFileUnified(file, this.$message)
        .catch(error => {
          console.error('文件下载失败:', error);
        });
    },
    handleRemove(file, fileList) {
      this.form.fileList = fileList
    },
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },
    handleSuccess(response, file, fileList) {
      this.form.fileList = fileList
      this.$message.success('文件上传成功')
    },
    handleError() {
      this.$message.error('文件上传失败')
    }
  }
}
</script>

<style scoped>
.testing-orders {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
}

.test-form {
  width: 100%;
}

.form-title {
  margin-bottom: 30px;
  color: #303133;
  font-size: 20px;
  text-align: center;
}

.form-card {
  width: 100%;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.el-form-item {
  margin-bottom: 22px;
  width: 100%;
}

.el-input,
.el-select,
.el-date-picker,
.el-radio-group,
.el-upload {
  width: 100%;
}

/* 两列布局 */
.form-row {
  display: flex;
  justify-content: space-between;
  margin: 0 -10px;
}

.form-col {
  flex: 1;
  padding: 0 10px;
}

/* 表单操作按钮 */
.form-actions {
  margin-top: 30px;
  text-align: center;
}

.form-actions .el-button {
  min-width: 120px;
  margin: 0 10px;
}

/* 上传区域样式 */
.upload-demo {
  width: 100%;
}

.el-upload__tip {
  margin-top: 10px;
  color: #909399;
}
</style> 